import React, {Component} from "react";
import CommToolContext from "containers/common/comm_tool_context";
import {withRouter} from 'react-router-dom';
import ProjectTabsList from "components/ProjectTabsList";
import ProjectTabsNavBar from "../../components/ProjectTabsList/ProjectTabsNavBar";

class ClosedTabs extends Component {
    state = {
        teamMembers :[],
        status:''
    };

    componentDidMount() {
        const {
            setActiveProject,
        } = this.props.context;
        setActiveProject(this.props.project);
    }

    render() {
        const {project,location,status, history, match} = this.props;
        return (
            <CommToolContext.Consumer>
                {context => (
                    <ProjectTabsNavBar project={project} context={context} location={status}/>
                      )}
            </CommToolContext.Consumer>
        );
    }
}

ClosedTabs.contextType = ClosedTabs;
export default withRouter(ClosedTabs);

